import { Component, input, InputSignal, OnDestroy, OnInit } from '@angular/core';

import { Subject, takeUntil } from 'rxjs';

import { TableHeaderComponent } from './table/table-header.component';
import { TitleCasePipe, DatePipe } from '@angular/common';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
  selector: 'app-disease-dashboard-widget-table-header',
  styleUrl: './widget.component.scss',
  template: `
    <div class="flex--row">
      <div class="crop-field-header flex__child--4 text--left">
        <span class="text--bold">{{ cropFieldLabelKey | translate }}</span>
      </div>
      @for (date of selectedDates(); track trackByDate($index, date)) {
        <div
          class="header-cell flex__child--2 text--center"
          [class.today]="isToday(date)"
        >
          @if (isToday(date)) {
            <span class="text--bold">{{ todayLabelKey | translate }}</span>
          }
          <span>{{ date | date: 'EE dd/MM': undefined: locale | titlecase }}</span>
        </div>
      }
    </div>
  `,
  imports: [
    TitleCasePipe,
    DatePipe,
    TranslatePipe,
  ],
})
export class DiseaseDashboardWidgetTableHeaderComponent extends TableHeaderComponent implements OnInit, OnDestroy {
  readonly translationPrefix: InputSignal<string> = input<string>('blightV2');

  protected get cropFieldLabelKey(): string {
    return `${this.translationPrefix()}.dashboardWidget.cropField`;
  }

  protected get todayLabelKey(): string {
    return `${this.translationPrefix()}.shared.today`;
  }

  protected destroy$ = new Subject<boolean>();
  protected locale!: string;

  public ngOnInit(): void {
    this.localeService.localeDataChanged$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.locale = this.localeService.getLocale();
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  protected trackByDate(_: number, date: Date): Date {
    return date;
  }
}
